// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3MwGG","title":"ClientInsurance_title__2pled","itemText":"ClientInsurance_itemText__6M02T"};